export const enum CreateGroupActionTypes {
  SET_MODAL = "@@CreateGroup/SET_MODAL",
  SET_MATTER = "@@CreateGroup/SET_MATTER",
}
